export function sortRegisters(variables) {
    return variables.sort((a, b) => {
      // Sort by direction first
      const directionOrder = {
        prelevement: 1,
        injection: 2,
      };
      
      // If one of the directions is missing, push it to the end
      if (!a.direction) return 1;
      if (!b.direction) return -1;
    
      if (directionOrder[a.direction] !== directionOrder[b.direction]) {
        return directionOrder[a.direction] - directionOrder[b.direction];
      }
    
      // If directions are the same, sort by timeframe
      const timeframeOrder = {
        TH: 1,
        HI: 2,
        LO: 3,
      };
      
      // If one of the timeframes is missing, push it to the end
      if (!a.timeframe) return 1;
      if (!b.timeframe) return -1;
    
      return timeframeOrder[a.timeframe] - timeframeOrder[b.timeframe];
    });
}